import React from 'react'
import { useTranslation } from 'react-i18next'
import CopyButton from '../components/CopyButton';
import NextSectionCard from '../components/NextSectionCard';
import { timeSince } from '../utils/timeSince';
import PreviousSectionCard from '../components/PreviousSectionCard';
import tutorialIcon from "../assets/icons/tutorial.svg";
import { Trans } from "react-i18next";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import step2 from "../assets/image/supportSign/step2.png";
import step3 from "../assets/image/supportSign/step3.png";
import step4 from "../assets/image/supportSign/step4.png";
import step5a from "../assets/image/supportSign/step5a.png";
import step5b from "../assets/image/supportSign/step5a.png";

const SupportSign = () => {
    const { t, i18n } = useTranslation();
    const lastUpdated = "2026-03-05";
    const lang = i18n.language;

    const buildCopyText = (t) => {
        return "";
    }
    return (
        <div className="text-black dark:text-white">
            <div
                className="
          desktop:px-4
          py-3
          max-w-3xl
        "
            >
                <div className="relative flex items-center justify-between gap-3">
                    <div className="flex items-center gap-1">
                        <div>
                            <img src={tutorialIcon} alt="tutorial" className="w-6 h-6" />
                        </div>
                        <div>
                            <p className="text-[16px] tabletpro:text-[14px] mini_mobile:text-[14px] text-[#0087FE] font-normal">
                                {t("sidebar.usage.title").toUpperCase()}
                            </p>
                        </div>
                    </div>

                    <CopyButton text={buildCopyText(t)} />
                </div>

                <div className="mt-2 relative">
                    <section className='flex gap-4'>
                        <p className='text-[#020617] dark:text-[#F8FAFC] text-[40px] tabletpro:text-[22px] mobile:text-[30px] mini_mobile:text-[24px] font-semibold'>{t("sidebar.usage.supportedSign")}</p>
                    </section>

                    <section className='flex flex-col gap-4 mt-1'>
                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="supportedSign.description"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>
                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="supportedSign.stepbystep"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>
                        <ul className="list-decimal pl-6 space-y-4">
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    <Trans
                                        i18nKey="supportedSign.step1"
                                        components={{
                                            strong: <span className="font-semibold" />,
                                        }}
                                    />
                                </p>
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9] gap-4">
                                    <Trans
                                        i18nKey="supportedSign.step2"
                                        components={{
                                            strong: <span className="font-semibold" />,
                                        }}
                                    />
                                </p>

                                <Zoom zoomMargin={80} zoomImg={{
                                    src: step2

                                }}>
                                    <img
                                        src={step2}
                                        alt="step2"
                                        className="max-w-full h-auto cursor-zoom-in mx-auto block mt-4"
                                    />
                                </Zoom>
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9] gap-4">
                                    <Trans
                                        i18nKey="supportedSign.step3"
                                        components={{
                                            strong: <span className="font-semibold" />,
                                        }}
                                    />
                                </p>

                                <Zoom zoomMargin={80} zoomImg={{
                                    src: step3

                                }}>
                                    <img
                                        src={step3}
                                        alt="step3"
                                        className="max-w-full h-auto cursor-zoom-in mx-auto block mt-4"
                                    />
                                </Zoom>
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9] gap-4">
                                    <Trans
                                        i18nKey="supportedSign.step4"
                                        components={{
                                            strong: <span className="font-semibold" />,
                                        }}
                                    />
                                </p>

                                <Zoom zoomMargin={80} zoomImg={{
                                    src: step4

                                }}>
                                    <img
                                        src={step4}
                                        alt="step4"
                                        className="max-w-full h-auto cursor-zoom-in mx-auto block mt-4"
                                    />
                                </Zoom>
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9] gap-4">
                                    <Trans
                                        i18nKey="supportedSign.step5"
                                        components={{
                                            strong: <span className="font-semibold" />,
                                        }}
                                    />
                                </p>

                                <Zoom zoomMargin={80} zoomImg={{
                                    src: step5a

                                }}>
                                    <img
                                        src={step5a}
                                        alt="step5a"
                                        className="max-w-full h-auto cursor-zoom-in mx-auto block mt-4"
                                    />
                                </Zoom>

                                <Zoom zoomMargin={80} zoomImg={{
                                    src: step5b

                                }}>
                                    <img
                                        src={step5b}
                                        alt="step5b"
                                        className="max-w-full h-auto cursor-zoom-in mx-auto block mt-4"
                                    />
                                </Zoom>
                            </li>
                        </ul>
                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="supportedSign.description2"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>
                    </section>

                    <section className='flex gap-4 mt-4 flex-col desktop:flex-row'>
                        <PreviousSectionCard
                            label={t("sidebar.usage.messageBox")}
                            to="/message-box"
                        />
                        <NextSectionCard
                            label={t("sidebar.cases.title")}
                            to="/usecase"
                        />
                    </section>

                    {/* Last updated */}
                    <section className='flex gap-4 mt-4'>
                        <span className="text-[14px] text-[#64748B]">
                            {t("welcome.lastUpdatedBase")} {timeSince(lastUpdated, lang)}
                        </span>
                    </section>
                </div>

            </div>
        </div>

    )
}

export default SupportSign
